import { token } from '@atlaskit/tokens';

export const GRADIENT_CTA_BUTTON_DEFAULT_START: 'var(--ds-chart-purple-bolder)' = token(
	'color.chart.purple.bolder',
);
export const GRADIENT_CTA_BUTTON_DEFAULT_END: 'var(--ds-chart-blue-bolder)' =
	token('color.chart.blue.bolder');
export const GRADIENT_CTA_BUTTON_HOVER_START: 'var(--ds-chart-purple-bolder-hovered)' = token(
	'color.chart.purple.bolder.hovered',
);
export const GRADIENT_CTA_BUTTON_HOVER_END: 'var(--ds-chart-blue-bolder-hovered)' = token(
	'color.chart.blue.bolder.hovered',
);
export const GRADIENT_CTA_BUTTON_ACTIVE_START: 'var(--ds-chart-purple-boldest)' = token(
	'color.chart.purple.boldest',
);
export const GRADIENT_CTA_BUTTON_ACTIVE_END: 'var(--ds-chart-blue-boldest)' = token(
	'color.chart.blue.boldest',
);

export const GRADIENT_BACKGROUND_SUBTLEST_START: 'var(--ds-background-accent-blue-subtlest)' =
	token('color.background.accent.blue.subtlest');

export const GRADIENT_BACKGROUND_SUBTLEST_END: 'var(--ds-background-accent-purple-subtlest)' =
	token('color.background.accent.purple.subtlest');

export const GRADIENT_CTA_BUTTON_INVERTED_BORDER_START: 'var(--ds-border-accent-purple)' = token(
	'color.border.accent.purple',
);

export const GRADIENT_CTA_BUTTON_INVERTED_BORDER_END: 'var(--ds-border-accent-blue)' = token(
	'color.border.accent.blue',
);

// (color.background.accent.purple.bolder.pressed, P900) from new color palette
export const GRADIENT_CTA_BUTTON_SELECTED_START: 'var(--ds-background-discovery-bold-pressed)' =
	token('color.background.discovery.bold.pressed');

// (color.background.accent.blue.bolder.pressed, B900) from new color palette
export const GRADIENT_CTA_BUTTON_SELECTED_END: 'var(--ds-background-selected-bold-pressed)' = token(
	'color.background.selected.bold.pressed',
);
